/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_CreateInputs */

const en_admin_categories_create = /** @type {(inputs: Admin_Categories_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Category`)
};

const zh_admin_categories_create = /** @type {(inputs: Admin_Categories_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建分类`)
};

/**
* | output |
* | --- |
* | "Create Category" |
*
* @param {Admin_Categories_CreateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_create = /** @type {((inputs?: Admin_Categories_CreateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_CreateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_create(inputs)
	return zh_admin_categories_create(inputs)
});
export { admin_categories_create as "admin.categories.create" }